// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { MapPinOff } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";
import { PageHeader } from "@/components/layout/page-header";
import { StatusPage } from "@/components/shared/status-page";

const ILLUSTRATION = { light: "/not-found-light.webp", dark: "/not-found-dark.webp" };

const IS_MAC = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.userAgent);

/** Rendered for any URL no route matches, inside the app shell — the sidebar is the way out. */
export function NotFound() {
  const { t } = useTranslation("back-office");

  return (
    <div className="flex min-h-full flex-col">
      <PageHeader title={t("notFound.title")} icon={MapPinOff} />
      <StatusPage
        illustration={ILLUSTRATION}
        title={t("notFound.title")}
        description={t("notFound.description")}
        footer={
          <Trans
            t={t}
            i18nKey="notFound.searchHint"
            values={{ shortcut: IS_MAC ? "⌘K" : "Ctrl K" }}
            components={{
              kbd: <kbd className="rounded border bg-muted px-1.5 py-0.5 font-mono text-[11px] text-foreground" />,
            }}
          />
        }
      />
    </div>
  );
}
